/*
 * Door Chooser — Monthly Protocol hub (§7.2, comp variant D).
 * Two select-cards share one CTA. Selecting a card highlights it and reflects
 * its door in the CTA label + link. The CTA always points at a subscribe-default
 * door PDP with NO query param (subscription-first; §2A.1). Idempotent.
 */
(function () {
  'use strict';

  function initChooser(section) {
    if (section.dataset.chooserBound === 'true') return;
    section.dataset.chooserBound = 'true';

    var radios = Array.prototype.slice.call(section.querySelectorAll('[data-door-radio]'));
    var cta = section.querySelector('[data-door-cta]');
    if (!radios.length || !cta) return;

    function reflect(radio) {
      section.querySelectorAll('[data-door-card]').forEach(function (card) {
        card.classList.toggle('is-selected', card.contains(radio));
      });
      var url = radio.getAttribute('data-cta-url') || '#';
      var label = radio.getAttribute('data-cta-label') || 'Choose your protocol';
      cta.setAttribute('href', url);
      cta.textContent = label;
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () { if (radio.checked) reflect(radio); });
    });

    // Boot: honour the server-checked (recommended) radio, else the first.
    var checked = radios.filter(function (r) { return r.checked; })[0] || radios[0];
    checked.checked = true;
    reflect(checked);
  }

  function init() {
    document.querySelectorAll('.door-chooser').forEach(initChooser);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
